import React from 'react';
import { NavLink } from 'react-router-dom';
import { format, parseISO, addDays, isThisWeek, isFuture } from 'date-fns';
import { it } from 'date-fns/locale';
import styles from './Sidebar.module.css';

function weekLabel(weekStart) {
  const start = parseISO(weekStart);
  const end = addDays(start, 6);
  return `${format(start, 'd MMM', { locale: it })} – ${format(end, 'd MMM yyyy', { locale: it })}`;
}

function weekBadge(weekStart) {
  const start = parseISO(weekStart);
  if (isThisWeek(start, { weekStartsOn: 1 })) return { label: 'Questa settimana', type: 'current' };
  if (isFuture(start)) return { label: 'Prossima settimana', type: 'future' };
  return null;
}

export default function Sidebar({ menus, loading, onUploadClick, collapsed, onToggle }) {
  const grouped = groupByYear(menus);

  return (
    <aside className={`${styles.sidebar} ${collapsed ? styles.sidebarCollapsed : ''}`}>
      <div className={styles.header}>
        {collapsed ? (
          <button className={styles.collapsedToggle} onClick={onToggle} title="Espandi menu">
            <span className={styles.logoIcon}>🥗</span>
          </button>
        ) : (
          <>
            <div className={styles.logo}>
              <span className={styles.logoIcon}>🥗</span>
              <span className={styles.logoText}>Menu Settimanale</span>
            </div>
            <div className={styles.headerRight}>
              <button className={styles.uploadBtn} onClick={onUploadClick} title="Carica nuovo menu">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="12" y1="5" x2="12" y2="19" />
                  <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
                Carica
              </button>
              <button className={styles.toggleBtn} onClick={onToggle} title="Comprimi menu">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
              </button>
            </div>
          </>
        )}
      </div>

      {!collapsed && (
        <nav className={styles.nav}>
          {loading && <p className={styles.loading}>Caricamento…</p>}
          {!loading && menus.length === 0 && (
            <p className={styles.empty}>Nessun menu ancora.<br />Carica il primo!</p>
          )}
          {Object.entries(grouped).map(([year, items]) => (
            <div key={year} className={styles.group}>
              <div className={styles.groupYear}>{year}</div>
              {items.map(menu => {
                const badge = weekBadge(menu.weekStart);
                return (
                  <NavLink
                    key={menu.id}
                    to={`/menu/${menu.id}`}
                    className={({ isActive }) => `${styles.item} ${isActive ? styles.itemActive : ''}`}
                  >
                    <div className={styles.itemLabel}>{weekLabel(menu.weekStart)}</div>
                    {badge && (
                      <span className={`${styles.badge} ${styles[`badge_${badge.type}`]}`}>
                        {badge.label}
                      </span>
                    )}
                  </NavLink>
                );
              })}
            </div>
          ))}
        </nav>
      )}
    </aside>
  );
}

function groupByYear(menus) {
  return menus.reduce((acc, menu) => {
    const year = menu.weekStart.slice(0, 4);
    if (!acc[year]) acc[year] = [];
    acc[year].push(menu);
    return acc;
  }, {});
}
